/**
 * Alert severity ladder and alert lifecycle states.
 *
 * Severity ordering matters for routing (alert rules filter on
 * "severity >= X") and for escalated-severity transitions on an
 * already-open alert.
 */
export const ALERT_SEVERITIES = ['warning', 'error', 'critical'];
export const ALERT_SEVERITY_ORDER = {
    warning: 1,
    error: 2,
    critical: 3,
};
/**
 * Alert lifecycle. `suppressed` alerts exist but are short-circuited at
 * routing (SDT / dependency suppression) — truth is preserved, noise is
 * filtered (technical-architecture.md §5.3).
 */
export const ALERT_STATUSES = [
    'open',
    'acknowledged',
    'suppressed',
    'resolved',
];
/** Why an alert reached `resolved`. External systems never force-clear a
 *  still-firing condition — the metric is the truth (CLAUDE.md). */
export const ALERT_RESOLVE_REASONS = [
    'cleared',
    'manual',
    'no_data_recovered',
    'sdt_expired_clear',
    'external_sync',
    // Detect's own decision (#85): the thing the alert measured was deleted, or its coverage was removed.
    'resource_deleted',
    'assignment_removed',
    'monitoring_disabled',
];
//# sourceMappingURL=severities.js.map